import utils from '@/utils/Utils.js'
// socketjs 文件地址
export const socketScript = `${window.location.origin}${utils.siteBase()}static/js/socket-io.js`;

// zxing js文件地址
export const zxingScript = `${window.location.origin}${utils.siteBase()}static/js/zxing.js`;

// 公告通知 列表
export const notice = '/api/notice'
// 公告通知 新建/编辑
export const noticeSave = '/api/notice/save'
// 公告通知 修改状态
export const noticeChange = '/api/notice/change'
// 公告通知 修改状态
export const noticeDelete = '/api/notice/delete'

// 个人中心
export const userCenter = '/api/user/center'

//一物一码新建
export const codeTrace = '/api/code_trace/save'
//一物一码修改
export const codeTraceEdit = '/api/code_trace/edit/{id}'
// 获取一物一码列表
export const codeTraceList = '/api/code_trace'
// 获取一物一码删除
export const codeTraceDelete = '/api/code_trace/delete'
// 获取一物一码打印
export const codeTracePrint = '/api/code_trace/print'
// 获取一物一码作废
export const codeTraceCancel = '/api/code_trace/cancel'
// 获取一物一码 核销统计列表
export const codeTraceStatistics = '/api/code_trace/statistics'
// 获取一物一码 核销统计详情
export const codeTraceStatisticsDetail = '/api/code_trace/statisticsDetail'
// 获取一物一码 撤销核销
export const codeTraceRevokeVerified = '/api/code_trace/revokeVerified'
// 核销
export const codeTraceVerified = '/api/code_trace/verified'

// 各数量统计
export const largScreEachNumSta = '/api/large_screen/eachNumberStatistics'
// 租户统计
export const largScreTenaStat = '/api/large_screen/tenantStatistics'
// 标签打印量趋势
export const printTendencyStatistics = '/api/large_screen/printTendencyStatistics'
// 租户打印统计
export const tenantPrintStatistics = '/api/large_screen/tenantPrintStatistics'

// 打印机管理
// 打印机新增、获取列表
export const printer = '/api/printer'
// 打印机新增、获取列表
export const printerSave = '/api/printer/save'
// 打印机新增
export const printerDelete = '/api/printer/delete'
// 打印机重置
export const printerReset = '/api/printer/reset'
// 打印机激活汇总统计列表
export const printerStatistics = '/api/printer/statistics'
// 打印机激活汇总统计详情
export const printerStatisticsDetail = '/api/printer/statisticsDetail'
// 打印机修改
export const printerEdit = '/api/printer/edit/'
// 打印机激活-查询打印机编号
export const printerNumberQuery = '/api/printer/numberQuery'
// 打印机激活
export const printerActivate = '/api/printer/activate'
// 打印机激活
export const printerImport = '/api/printer/import'
// 获取打印用户
export const printerUser = '/api/printer/getUser'

// 获取服务器事件
export const systime = '/api/project/time'

// 项目版本号
export const version = '/api/project/version'

// 项目版权信息
export const copyright = '/api/project/copyright'

// 器械检查列表
export const checkList = '/api/instrument/checkList'

// 器械检查 新增/编辑
export const checkSave = '/api/instrument/checkSave'
// 器械检查 删除
export const checkDel = '/api/instrument/checkDel'
// 器械保养列表
export const keepList = '/api/instrument/keepList'
// 器械保养 新增/编辑
export const keepSave = '/api/instrument/keepSave'
// 器械保养记录删除
export const keepDel = '/api/instrument/keepDel'

// 文件上传配置
export const uploadConfig = '/api/upload/token'

// 文件上传地址
export const upload = '/api/upload'

// 登录接口
export const login = '/api/auth/login'

// 单点登录
export const loginSSO = '/api/auth/login/sso'

// 用户信息
export const userInfo = '/api/user/self'

// 设置用户语言
export const setUserLang = '/api/user/locale'

// 扫码登录
export const scanLogin = '/api/auth/login/scan'

// 用户菜单
export const menu = '/api/user/menu'

// 获取ca用户
export const snUsers = '/api/user/getCaSn'

// 切换租户（超级管理员可用）
export const setTenant = '/api/user/tenant'

// 系统菜单权限
export const systemMenu = '/api/menu'

// 菜单文档上传删除
export const systemMenuFile = '/api/menu/file'

// 刷新token
export const refreshToken = '/api/common/token/refresh'

// 获取扫码规则
export const codeRule = '/api/common/encodeRule'

// 获取流程配置
export const functionConfig = '/api/common/getSysType'

// 角色列表
export const roleList = '/api/role'

// 角色包含权限
export const roleAuth = '/api/role/{id}/menu_id'

// 获取科室选项
export const departmentOptions = '/api/common/department'

// 获取含有包的科室选项
export const getManageDepartmentOptions = '/api/common/hasManageDepartment'

// 获取厂商选项
export const vendorOptions = '/api/common/vendors'

//获取人员
export const userOptions = '/api/common/getUser/{type}'

// 获取器械选项
export const instrumentOptions = '/api/common/instrument'

// 获取器械包选项
export const instrumentPackageOptions = '/api/common/instrumentset'

//多院区-获取待接收的物品名称
export const getOutPendingInstrumentset = '/api/takeOver/getOutPendingInstrumentset'


// 获取耗材选项
export const disposalOptions = '/api/common/disposable'

// 获取用户字典
export const getDict = '/api/common/getSysOptions'

// 获取院区列表
export const getSite = '/api/common/site'

// 扫码获取人员信息
export const scanCheckUser = '/api/common/checkUser'

//获取设备列表
export const getEquipment = '/api/common/equipment'

// 通过程序码获取设备
export const getEquipmentByProgram = '/api/common/getEquipmentByProgramCode'

// 设备获取程序列表
export const getEquipmentprogram = '/api/common/equipment/{id}/program'

// 获取锅次
export const getPotOptions = '/api/common/cleanPotFrequency'

//获取配置项
export const getSystype = '/api/common/getSysType'

// 查询器械包详情
export const getPackageDetail = '/api/common/instrumentset/{id}'

// 查询仓库列表
export const getWareHouseList = '/api/common/getWarehouse'

// 获取子科室选项
export const subDepartmentOptions = '/api/common/subDepartment'

// 获取科室组
export const departmentGroupOptions = '/api/common/departmentGroup'

// 获取用户科室范围
export const userDepartmentsAll = '/api/common/department/all'

// 从第三方获取科室
export const getDepartFromOther = '/api/department/getOtherSystemDep'

// 扫包码处理中心流转
export const scanCodeTransferCenter = '/api/common/scanTransferCenter'

// 记录人员扫码
export const scanUserCodeLog = '/api/common/scanUserCodeLog'

// 获取装载用具编码
export const getCartCode = '/api/common/getCartCode'

// 获取刻码包流程状态
export const getStatusByInnerCode = '/api/common/getStatusByInnerCode'

// 多科室用户登录设置科室
export const userSetDepartment = '/api/user/department/select'

// 获取处理中心列表
export const getCenter = '/api/center'

// 获取外来器械植入物配置
export const plantOptions = '/api/plant'

// 红柚账号设置处理中心
export const setCenter = '/api/user/center'

// 根据清洗架或灭菌架获取设备及程序
export const equipmentByShelf = '/api/common/getEquipmentByShelf/{code}'

// 检查包是否交接中
export const checkInstrumentSetHandOverStatus = '/api/common/isHandOver'

// 获取有效期配置项
export const deadlineConfiguration = '/api/common/deadline'

// 扫码播报包位置
export const scanAnnouncePosition = '/api/common/inner_code/status'

// 通过包码查询使用信息
export const getUseInfoByCode = '/api/common/getPatientByCode'

// 获取系统登记配置
export const getRegisterConfig = '/api/common/getRegisterConfig'

// 获取租户选项
export const getTenantOpts = '/api/common/getTenant'

// 获取租户用户选项
export const getUserOpts = '/api/common/getTenantUser'

// 获取租户科室选项
export const getTenantDepartment = '/api/common/getTenantDepartment'

// 获取省市区
export const getAddressOpts = '/api/common/getAddr'

// 基础数据模块
//修改密码
export const userPwd = '/api/user/pwd'

// 人员管理
// export const personList = '/api/user'

// // 人员编辑
// export const personEdit = '/api/user/{id}'

// // 人员删除
// export const personDelete = '/api/user/delete/{id}'

// // 人员停用
// export const personStop = '/api/user/stop/{id}'

// // 人员导入
// export const personImport = '/api/user/import'

// // 人员ca同步（彭州人民医院）
// export const personCAsync = '/api/user/seal'

// 获取已有租户的地址(省、市、区/县)
export const getAddrByTenant = '/api/common/getAddrByTenant'

// 获取租户最后一次打印数据
export const getLastPrint = '/api/common/getLastPrint'

// 更新日志
// 列表
export const iterationLog = '/api/iteration_log'
// 获取更新日志已发布版本号
export const getIterationVersion = '/api/common/getIterationVersion'
// 新增和修改
export const iterationLogSave = '/api/iteration_log/save'
// 删除
export const iterationLogDelete = '/api/iteration_log/delete'
// 已读
export const iterationLogRead = '/api/iteration_log/read'
// 是否存在未读的日志
export const iterationLogIsUnRead = '/api/iteration_log/isUnRead'

// 流程配置列表
export const functionList = '/api/system/sys_type'

// 流程配置新建/编辑
export const functionEdit = '/api/system/sys_type/{id}'

// 流程配置详情
export const functionDetail = '/api/system/sys_type/{id}'

// 流程配置删除
export const functionDelete = '/api/system/sys_type/delete/{id}'

// 字典配置列表/新增
export const dictList = '/api/system/sys_options'

// 字典配置编辑/详情
export const dictEdit = '/api/system/sys_options/{id}'

// 字典配置结构
export const dictOption = '/api/system/sys_options/getSysOptions'

// 字典配置删除
export const dictDelete = '/api/system/sys_options/delete/{id}'

//高低温设备信息登记
export const registerSave = '/api/system/register/save'
//登记导出
export const registerExport = '/api/system/register/export'
//登记导出模板
export const registerExportTemplate = '/api/system/register/exportTemplate'

// 篮筐推车置物架
export const containerList = '/api/basket'

// 篮筐推车置物架编辑
export const containerEdit = '/api/basket/{id}'

// 篮筐推车置物架删除
export const containerDelete = '/api/basket/delete/{id}'

// 篮筐推车置物架编码列表
export const containerCode = '/api/basket/getCode/{id}'

// 篮筐推车架文件列表
export const containerFile = '/api/basket/getFile/{id}'

// 篮筐推车架列表导入
export const containerImport = '/api/basket/import'

// 删除编码
export const deleteCode = '/api/basket/code/delete/{id}'

// 新增编码
export const addCode = '/api/basket/code/{id}'

// 导出篮筐推车架列表
export const exportContainer = '/api/basket/export'

// 获取所有篮筐类名称
export const getBasketList = '/api/basket/getBasketCartList'

// 载具编码编辑
export const containerCodeEdit = '/api/basket/basketCode/{id}'

// 器械包管理
export const instrumentPackage = '/api/instrumentset'

// 器械包编辑
export const instrumentPackageEdit = '/api/instrumentset/{id}'

// 器械包删除
export const instrumentPackageDelete = '/api/instrumentset/delete/{id}'

// 器械包批量删除
export const instrumentPackageBatchDelete = '/api/instrumentset/deleteBatch'

// 器械包导入
export const instrumentPackageImport = '/api/instrumentset/import'

// 基数导入
export const baseImport = '/api/instrumentset/baseImport'

// 导出器械包
export const instrumentPackageExport = '/api/instrumentset/export'

// 导出刻码包
export const instrumentCodePackageExport = '/api/instrumentset/exportCode'

// 器械包明细编辑
export const instrumentDetailEdit = '/api/instrumentset/instrument/{id}'

// 恢复器械包
export const instrumentPackageRestore = '/api/instrumentset/restore/{id}'

// 停用器械包
export const instrumentPackageDeprecate = '/api/instrumentset/deprecate/{id}'

// 器械包绑定附件
export const instrumentPackageBindFile = '/api/instrumentset/bindFile'

// 编辑器械包-列表页面编辑几项
export const instrumentEditColumns = '/api/instrumentset/editInstrumentsetColumns'

//多文件上传
export const uploadBatch = '/api/upload/batch'

// 器械维护-导出
export const instrumentRepairExport = '/api/instrument/repairExport'

// 设备管理
export const machineList = '/api/equipment'

// 设备删除
export const machineDelete = '/api/equipment/delete/{id}'

// 设备编辑 详情
export const machineEdit = '/api/equipment/{id}'

// 导入设备
export const importMachine = '/api/equipment/import'

//科室管理列表、新建
export const deptList = '/api/department'
// 编辑科室
export const deptEdit = '/api/department/{id}'
//科室删除
export const deptDelete = '/api/department/delete/{id}'
//导入科室
export const deptImport = '/api/department/import'
//处理中心新建
export const centerList = '/api/center'
//科室组管理列表、新建
export const deptGroupList = '/api/departmentGroup'
//科室组编辑
export const deptGroupEdit = '/api/departmentGroup/{id}'
//科室组删除
export const deptGroupDelete = '/api/departmentGroup/delete/{id}'
//院区新增
export const siteCreate = '/api/site'
//院区编辑
export const siteEdit = '/api/site/{id}'
//院区删除
export const siteDelete = '/api/site/delete/{id}'

// 从第三方拉取科室信息
export const deptPull = '/api/department/pull'

// 从第三方拉取器械包信息
export const packagePull = '/api/instrumentset/pull'



//效期管理
//获取效期管理列表
export const validationListUrl = '/api/system/deadline'
//更新有效期
export const updateValidationUrl = '/api/system/deadline'


//供应商列表
export const vendorsList = '/api/vendors'
//供应商修改
export const vendorsEdit = '/api/vendors/{id}'
//供应商删除
export const vendorsDelete = '/api/vendors/delete/{id}'

//器械列表
export const instrumentList = '/api/instrument'
//器械新增
export const instrumentCreate = '/api/instrument'
//器械编辑、详情
export const instrumentEdit = '/api/instrument/{id}'
//删除器械
export const instrumentDelete = '/api/instrument/delete/{id}'
//器械转为耗材
export const instrumentChange = '/api/instrument/change/{id}'
//导入器械
export const instrumentImport = '/api/instrument/import'
//导出器械
export const instrumentExport = '/api/instrument/export'
//检查udi绑定其他器械
export const checkInstrumentUdi = '/api/instrument/checkUDI'
// 器械绑定图片
export const instrumentBindImg = '/api/instrument/bindImg'

//耗材列表、新增
export const disposablesList = '/api/disposable'
//编辑耗材、详情
export const disposablesEdit = '/api/disposable/{id}'
//删除耗材
export const disposablesDelete = '/api/disposable/delete/{id}'
//耗材转器械
export const disposablesChange = '/api/disposable/change/{id}'
//导入耗材
export const disposableImport = '/api/disposable/import'
// 病人用品
export const patientSupplies = '/api/disposable/patient'

//模板列表、新增
export const templateList = '/api/template'
//模板详情、编辑
export const templateEdit = '/api/template/{id}'
//模板删除
export const templateDelete = '/api/template/delete/{id}'
//获取模板名称
export const getnameType = '/api/template/getName'
// 获取模版下拉
export const getTemplateGoods = '/api/template/getInstrumentset'

// 器械类列表
export const instrumentPartList = '/api/instrumentPartType'
// 器械类新增
export const instrumentPartCreate = '/api/instrumentPartType/create'
// 器械类编辑
export const instrumentPartUpdate = '/api/instrumentPartType/update'
// 器械类删除
export const instrumentPartDelete = '/api/instrumentPartType/delete'

// 主流程
// 回收
// 待回收列表
export const recycle = '/api/recycle'
// 手动回收
export const addRecycleFromDepart = '/api/recycle'
// 编辑待回收列表
export const editRecycle = '/api/recycle/{id}'
// 删除待回收列表
export const delRecycle = '/api/recycle/delete/{id}'
// 完成清点
export const finishRecycle = '/api/recycle/save'
// 回收批次
export const recycleBatchs = '/api/recycle/batch'
// 回收模版
export const recycleTemplates = '/api/recycle/template'
// 回收清点包统计
export const recyclePackageStatistic = '/api/recycle/count'
// 查询器械包
export const recycleInstrumentPackages = '/api/recycle/instrumentset'

// 登记不良事件
export const signProblem = '/api/recycle/problem'
// 编辑不良事件
export const editProblem = '/api/recycle/problem/{id}'
// 扫描刻码包回收
export const recycleCodePackage = '/api/recycle/scan/innerCode/{code}'
// 扫描标签码回收
export const recycleLabelPackage = '/api/recycle/scan/manageCode/{code}'
// 扫描科室申领单审核码回收
export const recycleApplyPackage = '/api/recycle/scan/approveCode/{code}'
// 代消包回收
export const recycleOtherhisPackage = '/api/recycle/out'
// 删除待回收列表
export const deleteRecycle = '/api/recycle/delete/'
// 回收外来器械
export const recycleOuter = '/api/recycle/foreign'
// 厂商送货人
export const outerUser = '/api/common/customerName/{id}'
// 厂商联系方式
export const outerContract = '/api/common/customerPhone/{id}'
// 借包记录
export const borrowList = '/api/borrow'
// 归还
export const borrowReturn = '/api/borrow/return'
// 是否逾期
export const checkOverDue = '/api/borrow/overdue'
// 刻码包状态
export const recycleStatus = '/api/recycle/status/{code}'
// 批量编辑
export const batchEditRecycle = '/api/recycle/batchUpdate'
// 篮筐是否空闲
export const rimLeisure = '/api/clean/basket/free/{code}'
// 根据科室时间聚合
export const pendingByDepartment = '/api/departmentApply/pendingByDepartment'
//新增器械包统计
export const applyNewInstrumentsetList = '/api/departmentApply/applyNewInstrumentsetList'
//打印回收清单
export const recyclePrint = '/api/recycle/recycle_code/print'
//申请差异记录
export const recycleWithApplyDiff = '/api/recycle/recycleWithApplyDiff'
//使用未回收器械
export const useInnerCodeHistory = '/api/recycle/useInnerCodeHistory'
//批量删除
export const recycleDeleteBatch = '/api/recycle/deleteBatch'
// 借包-修改删除状态
export const borrowDeleted = '/api/borrow/deleted'
// 待回收物品包码明细
export const recyclingPackageCodes = '/api/recycle/codeDetail/{id}'
// 保存删除包码
export const deleteRecyclingCodes = '/api/recycle/delete/code'


// 清点分类
//待分类列表
export const recycleList = '/api/clean/recycle'
//批量删除
export const recycleDelete = '/api/clean/recycle'
//从左至右
export const leftToright = '/api/clean/classify'
//已分类物品
export const cleanClassify = '/api/clean/classify'
//删除已分类物品
export const deleteClassify = '/api/clean/classify/delete'
//删除已分类篮筐
export const deleteBasket = '/api/clean/classify/{id}/basket/delete/{basket_code}'
//预处理
export const cleanPretreat = '/api/clean/pretreat'
//补录
export const cleanRefil = '/api/clean/refill'
//未分类物品补录
export const refillunclassified = '/api/clean/refill/unclassified'
// 待分类物品交接
export const sortHandOver = '/api/clean/handover'
// 待清洗的包回退到待回收
export const cleanRecycle = '/api/clean/back/recycle'


//清洗消毒
//待清洗消毒物品列表
export const disinfectionList = '/api/clean/ready'
// 校验选中篮筐中的包都是机洗
export const machineCheck = '/api/clean/machine/check'
// 勾选篮筐开始机洗
export const machineStart = '/api/clean/machine/start'
// 清洗机运行情况列表
export const machine = '/api/clean/machine'
// 清洗机运行情况详情
export const machineId = '/api/clean/machine/{id}'
//手洗
export const cleanhand = '/api/clean/hand'
//重新清洗
export const machineReclean = '/api/clean/machine/reclean/{id}'
//物品补录
export const refillclassified = '/api/clean/refill/classified'
//长龙开始清洗
export const changLongStart = '/api/clean/machine/changlong/start/{id}'
//清洗批次码打印
export const cleanPrint = '/api/clean/batch_code/print/{code}'

//清洗质检
//结束清洗
export const machineStop = '/api/clean/machine/stop/{id}'
//上传图片
export const machineFlie = '/api/clean/machine/{id}/file'
//删除图片
export const machineFliedelete = '/api/clean/machine/{id}/file/delete'
//清洗合格
export const machineSuccess = '/api/clean/check/success/machine/{id}'
//器械清洗不合格
export const machineinstrumentset = '/api/clean/check/fail/instrumentset/{id}'
//清洗机质检不合格
export const machineCheckfail = '/api/clean/check/fail/machine/{id}'
// 清洗全部回退
export const cleanRollBackAll = '/api/clean/rollback/all/{id}'
// 清洗单个回退
export const cleanRollBackOne = '/api/clean/rollback/instrumentset'
// 通过清洗架或篮筐查找最新的清洗信息
export const getCleanInfoByContainerCode = '/api/clean/getCleanByCode'
// 清洗分类器械包统计
export const getCleanSortPackageCount = '/api/clean/statistic/pack'

// 打印及包装
// 包装一检列表
export const packWaitList = '/api/pack/prepare'
// 包装一检组配
export const prepareToPack = '/api/pack/batch'
// 包装二检列表
export const packList = '/api/pack/packed'
// 包装二检回退
export const packToPrepare = '/api/pack/rollback'
// 包装二检信息保存
export const packEdit = '/api/pack/packed/info'
// 包装
export const packAudit = '/api/pack/audit'
// 总码打印
export const batchCodePrint = '/api/pack/print/batch/{batch_code}'
// 标签打印
export const tagPrint = '/api/pack/print/tag'
// 标签打印记录
export const tagPrintHistory = '/api/pack/print/history'
// 标签列表
export const tagList = '/api/pack/tag'
// 捆绑标签列表
export const bundleTagList = '/api/pack/bundle'
// 捆绑标签打印
export const bundleTagPrint = '/api/pack/print/bundle'
// 敷料包、代消包打印
export const specialPackagePack = '/api/pack/audit/special'
// 病人用品打印
export const patientSuppliesPack = '/api/pack/audit/patient'
// 一检回退
export const prepareBack = '/api/pack/rollback/clean'
// 标签编辑
export const tagEdit = '/api/pack/tag/{manage_id}'
// 暂存列表
export const stashList = '/api/pack/storage'
// 添加暂存
export const addStash = '/api/pack/storage/in'
// 暂存恢复
export const stashPop = '/api/pack/storage/out'
// 批量获取器械包详情（含包装信息）
export const batchPackageInfo = '/api/pack/batchPrint'
// 获取敷料包缓存列表
export const getDressingStashList = '/api/pack/tmpList'
// 提交敷料包缓存
export const postDressingStash = '/api/pack/saveTmpdata'
// 一检物品交接
export const prepareHandover = '/api/pack/handover'
// 扫码获取敷料包
export const packNoRecycle = '/api/pack/noRecycle'
// 标签删除（包装前调用）
export const beforeDelete = '/api/common/cancel/recycle/{node_type}'
// 标签删除（包装后调用）
export const laterDelete = '/api/common/cancel/manage/{node_type}'
// 包装一检打印待包装篮筐物品
export const basketPrint = '/api/pack/basket/item/print'
// 器械维修及报废
export const instrumentRepair = '/api/instrument/repair'
// 批量修改包装人 组配人 审核人
export const tagBatchModify = '/api/pack/tagBatchModify'
// 流程中断
export const packStop = '/api/pack/stop'

//单据列表
export const batchDepartment = '/api/pack/batch/department'
// 单据打印
export const batchDepartmentprint = '/api/pack/batch/department/print'
//获取批次码列表
export const batchCode = '/api/common/batchCode'
// 修改一检特殊备注
export const packSpecialRemark = '/api/pack/special_remark'

// 上架及灭菌
// 待灭菌列表
export const sterilizationWaitList = '/api/sterilization/waitList'
// 待灭菌列表删除
export const sterilizationWaitListDel = '/api/sterilization/delWaitList'
// 灭菌上架列表
export const sterilizationOnList = '/api/sterilization/shelfList'
// 灭菌上架列表删除
export const sterilizationOnListDel = '/api/sterilization/deleteShelf'
// 开始灭菌
export const startSterilization = '/api/sterilization/start'
// 灭菌器列表
export const sterilizationList = '/api/sterilization/statusList'
// 灭菌器内物品列表
export const sterilizationDetail = '/api/sterilization/shelfDetail/{id}'
// 扫描包码灭菌上架
export const scanCodeOn = '/api/sterilization/createShelf'
// 扫描包批次码灭菌上架
export const scanBatchOn = '/api/sterilization/createShelfBatchCode'
// 物品交接
export const sterilieHandOver = '/api/sterilization/handOver'
// 检查灭菌器当天是否bd
export const checkSteriBD = '/api/sterilization/isBd/{equipment_id}/{program_id}'
// 补录灭菌器查询
export const checkSteriList = '/api/sterilization/selectSterilizer'
// 查询锅次
export const checkSteriPots = '/api/sterilization/getPotFrequency'
// 保存灭菌补录
export const saveSteriAdded = '/api/sterilization/addSterilizationCollection'
// 当天扫描上架的包是否超出预期灭菌日期
export const checkSteriPackageOutdate = '/api/sterilization/isExceedSterilizeTime'
// 获取已上架灭菌器
export const getShelfedSteries = '/api/sterilization/equipment/onshelf/count'
// 获取一锅中相同器械包的数量
export const packageSummaryNum = '/api/sterilization/manageSum'
// 更换灭菌器
export const changeSterilizater = '/api/sterilization/chgEquipment'
// 批量上架
export const addSterilizer = '/api/sterilization/addToCurrentSterilizer'
// 灭菌上架 扫批次码下架
export const soldOutShelf = '/api/sterilization/soldOutShelf'
// 灭菌上架包编辑
export const updateShelf = '/api/sterilization/updateShelf'

//灭菌质检
//灭菌质检列表
export const sterilizationQualityList = '/api/sterilization/qualityList'
//灭菌质检上传图片
export const qualityUploadimg = '/api/sterilization/qualityUpload/{id}'
//灭菌质检删除图片
export const delQualityUpload = '/api/sterilization/delQualityUpload/{id}'
//灭菌质检结束
export const qualityFinish = '/api/sterilization/qualityFinish/{id}'
//灭菌质检合格
export const qualityQualified = '/api/sterilization/qualityQualified/{id}'
//灭菌质检主单据不合格
export const qualityUnQualified = '/api/sterilization/qualityUnQualified/{id}'
//不合格登记灭菌不合格补
export const newSter ='/api/qualityIssues/register?type=5' 
//灭菌质检单包不合格
export const singleQualityUnQualified = '/api/sterilization/singleQualityUnQualified/{id}'
// 灭菌质检回退
export const qualityRollback = '/api/sterilization/qualityRollback'
// 生物监测培养管异常
export const biologicalCulture = '/api/sterilization/biologicalCulture/{id}'
// 获取灭菌器最大锅次
export const getEquipmentMaxPot = '/api/sterilization/getMaxPotByEquipment'
// 程序当天是否提醒需要做生物监测
export const isBiologicalByProgram = '/api/sterilization/isBiologicalByProgram/{program_id}'

// 无菌库
// 无菌库列表
export const inventoryList = '/api/storage'
// 库存预警查询
export const inventoryAlert = '/api/storage/stock'
// 物品出库
export const inventoryOut = '/api/storage/normalOut'
// 过期物品出库
export const inventoryOutDateOut = '/api/storage/expiredOut'
// 扫码查询包信息
export const inventoryScanPackageInfo = '/api/storage/selectManageByCode'
// 确认退库
export const inventoryBack = '/api/storage/confirmReturn'
// 登记不合格
export const inventorySignUnqualified = '/api/storage/confirmUnQualified'
// 无菌库统计计数
export const inventoryCount = '/api/storage/count'
// 获取已过期包数量
export const inventoryOutdatePackage = '/api/storage/deadlineCount'
// 物品召回
export const packageCallBack = '/api/recall'
// 物品召回详情
export const callbackDetail = '/api/recall/detail'
// 重新组配
export const renewAssemble = '/api/recall/renewAssemble'
// 物品召回导出
export const packageCallBackExport = '/api/recall/export'
// 科室无菌库物品召回列表
export const departmentCallBackList = '/api/recall/departmentStorageRecallInfo'
// 科室无菌库效期查询
export const departmentStorageDeadline = '/api/departmentStorage/getDepartmentDeadline'
// 科室无菌库效期编辑
export const departmentStorageDeadlineEdit = '/api/departmentStorage/editDeadline'
// 包计数查询导出
export const departmentStorageCountExport = '/api/departmentStorage/countExport'

//兑换包查询列表
export const getExchangePackListUrl = '/api/storage/getExchangePackage'
//导出兑换包查询结果
export const exportExchangePackUrl = '/api/storage/exportExchangePackage'


//查询补录记录
export const getRefillRecordsUrl = '/api/statistics/addition'

//导出补录记录
export const exportRefillRecordUrl = '/api/statistics/export/addition'

// 六安查询报表
export const workStatisticForLuAn = '/api/statistics/workStatisticsForLuAn'


//无菌库盘库获取盘库记录
export const checkStorageRecordUrl = '/api/checkInventory'
export const newCheckTaskUrl = '/api/checkInventory'
//开始盘库
export const startCheckUrl = '/api/checkInventory/start'
//请求历史盘库数据
export const historyCheckRecordUrl = '/api/checkInventory/scanCodeList'
//发送扫码包数据
export const sendCodeUrl = '/api/checkInventory/scanCode'
//删除扫码结果
export const deleteHistoryItemURL='/api/checkInventory/delete'
//盘库完成
export const finishCheckUrl = '/api/checkInventory/finish'
//删除盘库任务
export const delCheckTaskUrl = '/api/checkInventory/deleteTask'
//导出盘库结果
export const exportCheckResult = '/api/checkInventory/export'
//获取盘库结果
export const getCheckResultUrl = '/api/checkInventory/result'

// 采样外送监测
// 器械包采样外送登记
export const monitorRegister = '/api/instrumentset/monitorRegister'
// 器械包采样外送登记列表
export const monitorRegisterList = '/api/instrumentset/monitorRegisterList'
// 通过包码获取供应室包 的包名
export const instrumentsetScanCode = '/api/instrumentset/scanCode'


//生物监测
//生物监测列表
export const sterilizationBiologicalList = '/api/sterilization/biologicalList'
//生物监测上传图片
export const biologicalUpload = '/api/sterilization/biologicalUpload/{id}'
//生物监测删除图片
export const delBiologicalUpload = '/api/sterilization/delBiologicalUpload/{id}'
//提前放行
export const biologicalLetGo = '/api/sterilization/biologicalLetGo/{id}'
// 单包提前放行
export const singleBiologicalLetGo = '/api/sterilization/singleBiologicalLetGo/{id}'
//生物监测合格
export const biologicalQuality = '/api/sterilization/biologicalQuality/{id}'
//不合格
export const biologicalUnQuality = '/api/sterilization/biologicalUnQuality/{id}'
//灭菌质量抽查包码查询
export const qualityManageByCode = '/api/sterilization/qualityManageByCode'
//灭菌质量抽查提交
export const createQualityLog = '/api/sterilization/createQualityLog'
//灭菌质检、生物监测列表详情
export const qualityBiologicalManage = '/api/sterilization/qualityManageList/{id}'
// 灭菌上架包生物监测标记
export const steriPackageMarkedBio = '/api/sterilization/updateBioTest'
// 灭菌包编辑
export const steriPackageEdit = '/api/sterilization/sterilizationManageEdit'
// 生物监测导出
export const exportBioList = '/api/sterilization/biologicalExport'
export const startBiological = '/api/sterilization/startBiological'

// 外来器械（短租）
// 外来器械回收
export const outerInstrumentRecycle = '/api/foreignInstrumentset/shortTerm/waitingRecycle'
// 回收/归还详情
export const outerInstrumentHandleDetail = '/api/foreignInstrumentset/shortTerm/{id}/handover'
// 外来器械注销
export const outerInstrumentSignout = '/api/foreignInstrumentset/shortTerm/cancel'
// 外来器械回收列表导出
export const outerInstrumentRecycleExport = '/api/foreignInstrumentset/shortTerm/waitingRecycle/export'
// 外来器械归还列表
export const outerInstrumentReturn = '/api/foreignInstrumentset/shortTerm/waitingReturn'
// 外来器械归还导出
export const outerInstrumentReturnExport = '/api/foreignInstrumentset/shortTerm/waitingReturn/export'
// 外来器械归还
export const outerInstrumentReturnHandle = '/api/foreignInstrumentset/shortTerm/return'
// 外来器械续用
export const outerInstrumentContinue = '/api/foreignInstrumentset/shortTerm/renew'
// 外来器械回收登记记录
export const outerInstrumentRecycleRecord = '/api/recycle/foreignRecord'
// 外来器械批量回收
export const outerInstrumentRecycleBatch = '/api/recycle/createByDeps'
// 外来器械查询列表
export const outerInstrumentList = '/api/foreignInstrumentset/shortTerm/statistics'
// 外来器械查询详情
export const outerInstrumentListDetail = '/api/foreignInstrumentset/shortTerm/statistics/{id}'
// 外来器械总览导出
export const outerInstrumentListExportSummary = '/api/foreignInstrumentset/shortTerm/statistics/export'
// 外来器械明细导出
export const outerInstrumentListExportDetail = '/api/foreignInstrumentset/shortTerm/statistics/detail/export'
// 外来器械病人信息
export const outerInstrumentPatientInfo = '/api/foreignInstrumentset/foreignList/{id}'
// 外来器械导出统计
export const outerInstrumentStatistic = '/api/foreignInstrumentset/outerInstrumentStatistic'
// 外来器械导出统计
export const outerInstrumentStatisticNumber = '/api/foreignInstrumentset/outerInstrumentStatisticNumber'
// 外来器械首次验证登记
export const outerInstrumentFirstTimeRegister = '/api/foreignInstrumentset/createFirstVerify'
// 外来器械首次验证列表
export const outerInstrumentFirstTimeRegisterList = '/api/foreignInstrumentset/getFirstVerifyList'
// 外来器械首次验证详情
export const outerInstrumentFirstTimeRegisterDetail = '/api/foreignInstrumentset/getFirstVerifyDetail'
// 外来器械首次验证保存
export const outerInstrumentFirstTimeRegisterSave = '/api/foreignInstrumentset/saveFirstVerify'
// 短租外来器械回收时归还
export const foreignInstrumentsetRecycleReturn = '/api/foreignInstrumentset/recycle/return'
// 短租外来器械回收时续用
export const foreignInstrumentsetRecycleRenew = '/api/foreignInstrumentset/recycle/renew'

// 短租外来器械点击续用列表详情
export const outerInstrumentShorTermDetail = '/api/foreignInstrumentset/shortTerm/detail'
//发放
//获取已过期包数量
export const deadlineCount = '/api/storage/deadlineCount'
// 待发放列表
//通过标签码添加发放
export const outIssue = '/api/out'
//通过包装批次码添加发放
export const outbatchCode = '/api/out/batchCode'
//通过灭菌批次码添加发放
export const outsterBatchCode = '/api/out/sterBatchCode'
//编辑
export const outId = '/api/out/{id}'
//删除
export const outDelete = '/api/out/delete/{id}'
//保存
export const outSave = '/api/out/save'
//汇总
export const outCount = '/api/out/count'
//提醒
export const outRemind = '/api/out/remind'
//记录
export const outRecord = '/api/out/record'
//记录已打印
export const outRecordPrinted = '/api/out/recordPrinted'
//历史记录未发放提醒
export const historyDate = '/api/out/need/remind/date'
//历史未发放数据归档
export const historyFile = '/api/out/need/finish'
//手动绑定
export const handleBound = '/api/out/need/bind'
//自动检库
export const automaticExamine = '/api/out/need/exchange/department'

//兑换包总览
//检库
export const outExchange = '/api/out/exchange'

//获取过期物品清库以及不合格数据
export const getManageList = '/api/storage/getManageList'

//列表导出，记录导出
export const outExport = '/api/out/export'
//汇总导出
export const outExportCount = '/api/out/export/count'
// 发放申领单物品列表
export const outApplicationPackages = '/api/out/applyInstrumentset/{code}'
// 扫码获取可发放物品
export const outReadyPackages = '/api/out/outReadyInstrumentset/{code}'
// 通过科室申领单添加发放
export const addOutByApplication = '/api/out/approveCode'
// 科室申领获取物品
export const getPackagesFromTemplate = '/api/departmentApply/applyRecycleGoodsByTemplate/{id}'

//查询
//工作量统计
export const workload = '/api/workload'
export const workloadDetail = '/api/workload/detail'
// 查询绩效系数
export const getWorkloadCoefficient = '/api/workload/getWorkloadCoefficient'
// 添加绩效系数
export const setWorkloadCoefficient = '/api/workload/addWorkloadCoefficient'
// 导出工作量系数
export const exportWorkloadList = '/api/workload/exportWorkloadCoefficient'
//使用登记日志
export const getSterilizationUnqualityLog = '/api/useRecord/getSterilizationUnqualityLog'

//包状态查询
export const getStatusList = '/api/instrumentsetStatistics/getStatusList'
export const getInnerCodeByNode = '/api/instrumentsetStatistics/getInnerCodeByNode'
// 刻码包状态查询
export const getInnerCodeList = '/api/instrumentsetStatistics/getInnerCodeList'
// 科室包查询
export const departmentInstrumentsetInquire = '/api/instrumentsetStatistics/getInstrumentsetNumber'
// 科室包查询导出
export const departmentInstrumentsetInquireExport = '/api/instrumentsetStatistics/getInstrumentsetNumberExport'

//科室收发明细查询
export const recycleBatch = '/api/recycle/recycleBatch'
export const recycleBatchDetail = '/api/recycle/recycleBatchDetail'


// 湿包列表查询
export const getWetList = '/api/quality/wetList'
// UDI查询
export const getUdiList = '/api/udi'
// udi查询详情
export const getUdiDetail = '/api/udi/detail'
// udi 器械名称下拉
export const getUdiName = '/api/udi/instrument'
// cssd 库存包查询列表
export const inventoryPack = '/api/statistics/inventoryPack'
// cssd 库存包导出
export const exportInventoryPack = '/api/statistics/export/inventoryPack'
// cssd 库存包详情列表
export const detailInventoryPack = '/api/statistics/inventoryPackById'
// 追溯查询灭菌修改
export const inquireSteriModify = '/api/statistics/editSterilization'
// 质量抽查查询
export const qualityStatisticsList = '/api/quality/qualityList'
// 科室使用登记查询列表
export const departmentUseRecordList = '/api/useRecord/departmentUseRecordList'
// 科室使用登记查询明细的列表
export const departmentUseRecordDetailList = '/api/useRecord/departmentUseRecordDetailList'
// 使用登记修改图片（开启缓存时）
export const useRecordModifyPicture = '/api/useRecord/manage/image'
// 使用登记缓存列表
export const useRecordStashList = '/api/useRecord/unRecordpatient/list'
// 使用登记缓存列表删除包
export const useRecordStashListDelete = '/api/useRecord/unRecordpatient/delete'
//回收/发放/包装统计
export const statisticspackCount = '/api/statistics/packCount'
// 点击按钮获取患者使用记录-列表
export const useRecordGetPatientList = '/api/useRecord/getPatientList'


// 消息通知
// 发布列表
export const messagePublishList = '/api/message'
// 接收列表
export const messageReceiveList = '/api/message/receive'
// 删除消息
export const messageDelete = '/api/message/delete/{id}'
// 消息已读
export const messageRead = '/api/message/read'
// 通知列表
export const messageNoticeList = '/api/notice/published'
// 关闭消息广播
export const messageClose = '/api/message/close'


//追溯查询
//灭菌
export const querySterilization = '/api/statistics/sterilization'
export const querySterilizationSubList = '/api/statistics/sterilizationSubList/{id}'
export const querysterilizationExport = '/api/statistics/sterilizationExport'
//灭菌标签补打
export const querysterilizationPrint = '/api/statistics/sterilizationPrint/{id}'

//回收
export const queryRecycle = '/api/statistics/recycle'
export const queryrecycleExport = '/api/statistics/export/recycle'
//回收统计
export const queryRecycleCount = '/api/statistics/recycleCount'
export const queryRecycleCountExport = '/api/statistics/export/recycleCount'
export const queryRecycleTotalExport = '/api/statistics/export/recycleTotal'
export const queryRecycleDepartment = '/api/statistics/recycleDepartment'
export const queryRecycleDepartmentPrint = '/api/statistics/recycleDepartmentPrint'

//修改加急状态
export const recycleUrgent = '/api/recycle/urgent'

//清洗
export const queryClean = '/api/statistics/clean'
export const exportClean = '/api/statistics/export/clean'
export const queryCleanID = '/api/statistics/clean/{id}'
//发放
export const queryOut = '/api/statistics/out'
export const queryOutexport = '/api/statistics/export/out'
//发放统计
export const queryoutCount = '/api/statistics/outCount'
export const exportoutTotal = '/api/statistics/export/outTotal'
export const exportoutCount = '/api/statistics/export/outCount'
export const exportoutCostTotal = '/api/statistics/export/outCostTotal'
export const exportoutCostBydepartment = '/api/statistics/export/outCost'
//追溯查询
export const queryGoodsTrace = '/api/statistics/goodsTrace'
//追溯查询打印
export const foreignPrint = '/api/foreignInstrumentset/shortTermForeignPrint/{manage_id}'
//月度统计
// 灭菌工作量
export const monthsterInstrumentset = '/api/month/sterilization/department'
export const monthsterDate = '/api/month/sterilization/date'
// 灭菌工作量查询详情
export const monthsterDetail = '/api/month/sterilization/getNumberDetail'
// 清洗工作量
export const monthcleanDept = '/api/month/clean/department'
export const monthcleanDate = '/api/month/clean/date'
export const getAllProgram = '/api/common/equipment/getAllProgram'

//清洗包工作量
export const monthcleanInstrumentset = '/api/month/clean/instrumentset'
//发放包工作量
export const monthoutInstrumentset = '/api/month/out/instrumentset'
// 以发放节点计算工作量
export const monthoutDepartment = '/api/month/out/department'
// 追溯查询-月度统计-发放包数量导出（按包和科室）
export const monthoutExportDepartment = '/api/month/export/outDepartment'
// 追溯查询-月度统计-退库问题统计
export const monthOutReturn = '/api/month/out/return'
// 追溯查询-月度统计-退库问题导出
export const monthOutReturnExport = '/api/month/export/outReturn'

export const monthPackageDate = '/api/month/package/date'
export const monthExportPackageDate = '/api/month/package/exportPackage'
// 导出
export const monthExportSter = '/api/month/export/sterilization'
export const monthExportClean = '/api/month/export/clean'
export const monthExportCleaninstrument = '/api/month/export/cleanInstrumentset'
export const monthExportOut = '/api/month/export/out'
//月度统计
export const statisticsYear = '/api/statistics/year'
export const statisticsexportYear = '/api/statistics/export/year'
export const statisticsMonth = '/api/statistics/month'
export const statisticsexportMonth = '/api/statistics/export/month'
//交接记录
export const takeOver = '/api/takeOver'
// 待交接记录
export const takeOverPending = '/api/takeOver/outPending'
// 拒绝交接
export const takeOverReject = '/api/takeOver/reject/{id}'
// 提前放行记录
export const letGoRecords = '/api/month/sterilization/letGo'
// 多院区-交接单
export const takeOverPrint = '/api/takeOver/{code}'
// 获取无菌库扫码交接的包
export const getStorageTakeOvers = '/api/common/getManageHandOverByCode'

// 科室对接
// 物品接收列表
export const receiveList = '/api/departmentStorage/receive'
// 物品接收保存
export const receiveSave = '/api/departmentStorage/saveReceive'
// 物品接收记录
export const receiveRecord = '/api/departmentStorage/receiveLog'
// 物品接收记录导出
export const receiveRecordExport = '/api/departmentStorage/receiveLogExport'
// 物品接收记录详情
export const receiveRecordLog = '/api/departmentStorage/receiveLogDetail'
//发放回收对照
export const contrast = '/api/departmentStorage/contrast'
// 物品接收扫码校验
export const receiveScanCheck = '/api/departmentStorage/checkScanReceive'
// 物品接收当日总数
export const receiveDayCount = '/api/departmentStorage/receiveCountByOnDay'
// 物品接收-科室退库至供应室无菌库
export const departmentReturn = '/api/storage/department/return'
// 供应室确认科室退库
export const departmentConfirm = '/api/storage/department/return/confirm'
// 查询可接收的码
export const getScanCodeToReceive = '/api/departmentStorage/scanCode'

// 科室申领单提交和暂存(回收/发放)
export const departmentApplication = '/api/departmentApply'
// 科室申领记录
export const departmentApplicationHis = '/api/departmentApply/applyList'
// 科室申领使用污包列表
export const departmentApplicationUsed = '/api/departmentApply/usedList'
// 删除污包
export const departmentApplicationUsedDelete = '/api/departmentApply/usedDelete'
// 科室申领回收申请物品列表
export const departmentApplicationPackages = '/api/departmentApply/applyRecycleGoods'
// 删除申领单中物品
export const departmentApplicationPackageItemDelete = '/api/departmentApply/applyInstrumentsetDelete'
// 发放申请物品
export const departmentapplyOutGoods = '/api/departmentApply/applyOutGoods'
// 科室申领单-待审核列表（回收/发放）
export const departmentapprovePending = '/api/departmentApply/approve/pending'
// 科室申领单-拉取第三方
export const departmentapprovePullHistory = '/api/departmentApply/approve/pullHistory'
// 科室申领提交审核
export const departmentApplicationAudit = '/api/departmentApply/approve'
//刻码包是否已被申请
export const departmentcheckInnerCode = '/api/departmentApply/checkInnerCode'
// 科室申请单详情（打印数据）
export const departmentApplicationDetail = '/api/departmentApply/applyDetail/{id}'
// 科室审核取消
export const departmentApplicationCancel = '/api/departmentApply/approve/cancel'
//审核记录
export const departmentApplyhistory = '/api/departmentApply/approve/history'
// 导出回收数据
export const getRecycleExportInfo = '/api/departmentApply/approve/export'
// 审核记录打印（回收/发放）
export const departmentAuditPrintDetail = '/api/departmentApply/approve/print/{id}'
// 批量审核记录打印（回收/发放）
export const departmentAuditBatchPrintDetail = '/api/departmentApply/approve/batchPrint'
// 批量亳州打印（回收）
export const departmentAuditCalculatePrintDetail = '/api/departmentApply/approve/calculatePrint'
// 修改科室回收申请记录界面批次
export const updateCartCode = '/api/departmentApply/updateCartCode'
// 手术配包-获取手术配包信息
export const getOperationInfo = '/api/common/getOperationInfo'
// 手术配包-手术配包列表
export const getOperationList = '/api/template/getOperationList'
// 手术配包-保存
export const saveOperationInfo = '/api/template/saveOperationInfo'
// 手术配包-查看详情
export const getOperationDetail = '/api/template/getOperationDetail'
// 手术配包-编辑
export const updateOperationInfo = '/api/template/updateOperationInfo'
// 手术配包
export const deleteOperationInfo = '/api/template/deleteOperationInfo/{id}'
// 撤销申请单
export const applyCancel = '/api/departmentApply/applyCancel/{id}'
// 修改科室对接 - 回收申请记录界面单条批次
export const updateInstrumentsetCartCode = '/api/departmentApply/updateInstrumentsetCartCode'

// 审核标记
export const departmentMark = '/api/departmentApply/approve/mark/{id}'
// 隐藏/恢复回收审核记录
export const departmentApplicationHideRestore = '/api/departmentApply/approve/approveHide/{id}'
// 回收申请扫码添加
export const departmentApplicationScan = '/api/departmentApply/scanCodeApply'
// 过滤复制记录
export const filterCopyRecord = '/api/departmentApply/copyCheck'
// 过滤污包
export const filterUsedRecord = '/api/departmentApply/usedAddCheck'
// 敷料包、代消包 一键发放
export const dressingPackagesOut = '/api/departmentApply/pack/noRecycle'
// 回收申请审核撤销
export const recycleApplicationAuditCallback = '/api/departmentApply/applyInstrumentsetCancel'
// 回收发放审核单复制
export const copyPrintSection = '/api/departmentApply/auditCopy/{id}'

// 耗材申请提交
export const consumableApplicationPost = '/api/departmentApply/consumablesApply'
// 耗材申请缓存
export const consumableApplicationStash = '/api/departmentApply/consumablesApplyStashList'
// 耗材申请记录
export const consumableApplicationRecord = '/api/departmentApply/consumablesApplyList'
// 耗材申请记录导出
export const consumableApplicationRecordExport = '/api/departmentApply/exportConsumablesApplyList'
// 耗材申请记录复制
export const consumableApplicationRecordCopy = '/api/departmentApply/consumablesApplyCopy/{id}'
// 耗材申请打印
export const consumableApplicationPrint = '/api/departmentApply/consumablesApplyPrint'
// 科室申请驳回
export const departmentApplicationReject = '/api/departmentApply/cancel'
// 检查刻码科室申请是否已被申请
export const getAllowApplyCode = '/api/departmentApply/getAllowApplyCode'
// 下收登记查询列表
export const getReceiveList = '/api/departmentApply/getApplyInstrumentsetCodeList'
// 下收登记交接
export const receivePost = '/api/departmentApply/receive'
// 恢复污包被删除的包码
export const recoverRemovedUsedInstrumentset = '/api/departmentApply/usedRecover'
export const receiveByPrint = '/api/departmentApply/receiveByPrint'



// 科室无菌库列表
export const departmentStorageList = '/api/departmentStorage'
// 科室无菌库出库记录
export const departmentStorageRecord = '/api/departmentStorage/record'
// 科室无菌库出库
export const departmentStorageOut = '/api/departmentStorage/out'
// 科室无菌库分配手术间
export const departmentStorageDistribute = '/api/departmentStorage/distribute'
// 科室无菌库手术间退库
export const departmentStorageReturn = '/api/departmentStorage/return'
// 科室无菌库包计数
export const departmentStorageCount = '/api/departmentStorage/count'
// 科室无菌库包计数
export const departmentStorageScan = '/api/departmentStorage/scan/{code}'
// 科室无菌库-获取当天过期包数量
export const departmentStorageExpired = '/api/departmentStorage/getExpiredNumberByDay'

//使用登记
export const useRecordinstrumentset = '/api/useRecord/instrumentset/{code}'
//病人信息保存
export const saveUnRecordpatient = '/api/useRecord/saveUnRecordpatient'
//病人信息获取
export const unRecordpatient = '/api/useRecord/unRecordpatient'
//获取手术间
export const useRecordDepartmentroom = '/api/useRecord/department/room'
// 手术间物品转让
export const transfer = '/api/departmentStorage/transfer'
//患者使用记录
// 列表、使用登记保存
export const useRecord = '/api/useRecord'
//列表展开详情
export const useRecorddetail = '/api/useRecord/detail'
//取消使用
//取消使用登记列表
export const useRecordcancel = '/api/useRecord/cancel'
//记录导出
export const useRecordexport = '/api/useRecord/export'
//物品合计导出
export const useRecordSumExport = '/api/useRecord/exportSum'
// 根据病人码查记录
export const useRecordInfo = '/api/useRecord/patient'

//器械问题登记
//器械分组
export const instrumentTopLists = '/api/instrumentPartType/topLists'
//问题类型联级查询
export const getIssueConfig = '/api/issue/getIssueConfig'
//问题查询列表
export const getIssueList = '/api/issue/list'
//删除
export const getIssueDelete = '/api/issue/delete/{id}'
// 标记解决
export const markIssueResoled = '/api/issue/solve/{id}'

// 问题登记
// 获取问题类型
export const instrumentQuestionTypes = '/api/issue/getIssueType'
// 获取流程包列表
export const processPackages = '/api/issue/instrumentsetOptions'
// 问题登记保存
export const processQuestionDetail = '/api/issue'
// 获取问题登记的问题
export const getIssueProblem = '/api/issue/getIssueProblem'

//台州医院新发放
//待发放列表
export const outNeed = '/api/out/need'
//待发放列表删除
export const outNeeddelete = '/api/out/need/delete'
//待发放科室及数量
export const outNeednumber = '/api/out/need/number'
//新增其他器械包
export const outNeednewscan = '/api/out/need/new/scan'
export const outNeednewSave = '/api/out/need/new/save'
//扫码补录包
export const refillStercode = '/api/sterilization/refill/{code}'
//打印待发放物品
export const needPrint = '/api/out/need/print'
// 批量亳州打印（发放）
export const outPrintDetail = '/api/out/outRecordPrint'
//备注列表
export const remarkList = '/api/remark/index'
//备注添加/编辑
export const remarkEdit = '/api/remark/edit/{id}'
//详情
export const remarkDetail = '/api/remark/edit/{id}'
//备注删除
export const remarkDelete = '/api/remark/delete/{id}'
//盘库列表
export const operateInventoryList = '/api/handover/operateInventoryList'
//回收时间超过24小时的
export const overtimeList = '/api/handover/overTimeList'
//获取刻包码位置
export const instrumentsetCodeAddress = '/api/common/getInstrumentsetCodeAddressDict'
// 手动输入包码绑定
export const handleBindCode = '/api/out/need/bind/code'
// 科室包显示发放数量和回收数量
export const getNumberList = '/api/out/getNumber'
// 待发放借包列表
export const borrowPackList = '/api/out/need/borrow'
// 待发放借包列表扫码
export const borrowPackScan = '/api/out/need/borrow/scan'
// 待发放借包发放
export const borrowPackSave = '/api/out/need/borrow/save'
// 兑换包发放记录
export const exchangeOutRecord = '/api/out/exchangeRecord'

// 耗材库
// 库房管理
export const storeHouseManage = '/api/warehouse'
// 库房详情
export const storeHouseDetail = '/api/warehouse/{id}'
// 删除仓库
export const storeHouseDel = '/api/warehouse/deleted'
// 导入仓库
export const storeHouseImport = '/api/warehouse/import'
// 复制仓库
export const storeHouseCopy = '/api/warehouse/copy/{id}'
// 入库/出库列表
export const consumableList = '/api/warehouseMission'
// 删除/批量删除
export const consumableDelete = '/api/warehouseMission/deleted'
// 获取所有仓库的id
export const allWarehouse = '/api/warehouse/getIds'
// 执行入库操作
export const consumableIn = '/api/warehouseMission/exec'
// 入库任务的新建和修改
export const consumableBuildRevise = '/api/warehouseMission'
// 获取厂商
export const consumableManufacturer = '/api/common/customerBytype/{type}'
// 修改任务状态为完成
export const consumableUpdata = '/api/warehouseMission/updateStatusFinish/{id}'
// 拒绝入库
export const consumableRefuse = '/api/warehouseMission/cancel'
// 修改查看获取任务详情
export const consumableTaskDetail = '/api/warehouseMission/{id}'
// 获取仓库信息
export const consumableStorehouseNew = '/api/warehouseMission/getCartCodeByInstrumentId'
// 库存列表
export const consumableInventory = '/api/warehouseStorage'
// 库存总量和总价
export const consumableNumberPrice = '/api/warehouseStorage/totalPrice/{id}'
// 库存出入库明细
export const consumableDetail = '/api/warehouseStorage/getPutOutDetail/{id}'
// 库存编辑
export const consumableEdit = '/api/warehouseStorage/safeNumber/{id}'
// 库存批次列表
export const consumableRecord = '/api/warehouseStorage/{id}/putDetail'
// 库存列表导出
export const consumableExport = '/api/warehouseStorage/export'
// 库存导出
export const consumableListExport = '/api/warehouseStorage/exportList'
// 库存问题记录
export const consumableRegister = '/api/warehouseStorage/issueRecord'
// 库存问题登记列表
export const consumableRegisterList = '/api/warehouseStorage/issues'
// 出入库明细导出
export const consumableDetailExport = '/api/warehouseStorage/exportDetail'
// 库存问题删除
export const consumableIssueDelete = '/api/warehouseStorage/issues/delete'
// 耗材撤销出库
export const consumableOutRevoke = '/api/warehouseStorage/outRevoke'
// 出库获取品牌下拉
export const consumableGetOutBrand = '/api/warehouseMission/getInstrumentBrand'
// 库房下载
export const consumableDownload = '/api/warehouse/export'
// 获取耗材库存数量
export const consumableStockNumber = '/api/warehouseMission/getNumber'
// 获取器械
export const getApparatusName = '/api/warehouseMission/getInstrument'
// 获取耗材
export const getConsumableOptions = '/api/warehouseMission/getCosumable'
// 获取有库存的耗材
export const getConsumableOptionsWithStock = '/api/warehouseMission/getStorageCosumable'
// 系统出库-科室申请列表
export const getByDepartment = '/api/warehouseMission/getByDepartment'
// 系统出库-根据任务id出库
export const outByMissionId = '/api/warehouseMission/outByMissionId'
// 耗材出库-导出
export const consumableOutExport = '/api/warehouseMission/exportByOut'
//系统出库完成-打印
export const printByAppNumber = '/api/warehouseMission/printByAppNumber'
// 库房管理-打印
export const warehouseMissionPrint = '/api/warehouseMission/print'
//出库汇总-查询
export const getOutListByLabelType = '/api/warehouseMission/getOutListByLabelType'
// 查询系统申请出库数量
export const getConsumableApplyOutCount = '/api/warehouseMission/getApplyOutQuantity'

// 质控平台
// 质控各项指标
export const qualityPlatform = '/api/quality/platformQuota'
// 包装不合格-登记
export const qualityIssuesRegister = '/api/qualityIssues/register'
// 包装不合格-详情
export const qualityIssuesDetail = '/api/qualityIssues/detail'
// 包装不合格-列表
export const qualityIssuesList = '/api/qualityIssues/list'
// 包装不合格-导出
export const qualityIssuesExport = '/api/qualityIssues/export'
// 包装不合格-器械包名称
export const qualityIssuesInstrumentsetName = '/api/qualityIssues/getInstrumentsetName'
// 根据包码获取发放详情
export const recordCode = '/api/out/record/code'
// 年报-获取医院信息登记
export const yearBase = '/api/qc/v1/year/base'
// 年报-保存医院信息登记
export const yearBasePreserve = '/api/qc/v{api_version}/year/base'
// 年报-获取复用器械集中管理明细
export const yearInstrument = '/api/qc/v1/year/instrument'
// 年报-岗位培训率明细
export const yearStation = '/api/qc/v1/year/station'
// 年报-继续教育率明细
export const yearEducation = '/api/qc/v1/year/education'
// 年报-获取字典
export const yearOptions = '/api/qc/v1/year/options'
// 年报-职业暴露发生率
export const yearExplode = '/api/qc/v1/year/explode'
// 年报-设备定期维护/检测完成率明细
export const yearEquipment = '/api/qc/v1/year/equipment'
// 年报-导入年报
export const yearImport = '/api/qc/v1/year/import'
// 年报-导出年报
export const yearExport = '/api/qc/v1/year/export'

// udi相关
// 绑定udi
export const saveUdi = '/api/udi/save'
// 删除udi
export const deleteUdi = '/api/udi/delete'
// 获取刻码包器械明细
export const CodeInstrumentSetDetail = '/api/instrumentset/inner_code/{code}/instrument'
// 校验udi是否已绑定刻码包
export const checkUdiBindCodeInstrumentsetStatus = '/api/udi/inner_code/check'
// 刻码包绑定udi
export const codeInstrumentSetBindUdi = '/api/instrumentset/inner_code/{code}/udi'
// 刻码包解绑udi
export const codeInstrumentSetUnbindUdi = '/api/instrumentset/inner_code/{code}/udi/delete'
// 查询udi已绑定其他包和器械
export const checkUdiBindOthers = '/api/udi/inner_code'

// 排班管理
// 排班列表
export const getArrange = '/api/arrange/getArrange'
// 排班保存
export const workSave = '/api/arrange/save'
// 排班保存
export const arrangeSave = '/api/arrange/createWorkArrange'
// 导入排班
export const importArrange = '/api/arrange/importArrange'
// 导出排班
export const exportArrange = '/api/arrange/exportArrange'

// 编辑日志查询
export const editRecordList = '/api/record/editRecordList'
// 删除日志查询
export const deleteRecordList = '/api/record/deleteRecordList'
// 回退日志查询
export const rebackRecordList = '/api/record/rebackRecordList'


//系统配置(实施用)
//刷新配置缓存
export const sysCacheRefresh = '/api/sys/cache/refresh'
//流程配置导入
export const sysTypeSave = '/api/sys/sys_type/save'
//数据字典导入
export const sysOptionSave = '/api/sys/sys_option/save'
//表头导入
export const sysColumnSave = '/api/sys/column/save'
//菜单导入
export const sysMenuSave = '/api/sys/menu/save'
//人员菜单批量导入
export const sysUserMenuBatch = '/api/sys/user/menu/batch/'
//菜单导入
export const sysInnerCodeStuckDelete = '/api/sys/inner_code/stuck/delete/'
//读取日志
export const readLog = '/api/sys/log/read'
//复制流程配置
export const sysTypeCopy = '/api/sys/sys_type/copy'
//复制数据字典
export const sysOptionCopy = '/api/sys/sys_option/copy'

//成本控制列表
export const costList = '/api/cost/index'
//成本控制保存
export const costSave = '/api/cost/save'
//成本控制删除
export const costDelete = '/api/cost/delete/{id}'
//成本控制列表
export const costTypeList = '/api/cost/typeIndex'
//成本控制保存
export const costTypeSave = '/api/cost/typeSave'
//成本控制删除
export const costTypeDelete = '/api/cost/typeDelete/{id}'
//分担成本核算列表
export const calculateList = '/api/cost/calculateList'
//保存
export const saveCalculate = '/api/cost/saveCalculate'
//折线图数据
export const chartLineData = '/api/cost/chartLine'
//直接成本列表
export const directCostList = '/api/cost/getDirectCostList'
//导出直接成本
export const exportDirectCostList = '/api/cost/exportDirectCostList'
//发放科室成本列表
export const outDepartmentCostList = '/api/cost/outDepartmentCostList'

// 获取任务安排列表
export const getPlanTask = '/api/equipmentInspection/planTask'

export const getPlanTaskInfo = '/api/equipmentInspection/recordsConfig'

export const subMaintenanceRecords = '/api/equipmentInspection/maintenanceRecords'

// 设备巡检
// 计划列表
export const planList = '/api/equipmentInspection/plan_list'
// 计划创建/更新
export const planNewUpdata = '/api/equipmentInspection/plan'
// 查看计划
export const planDetail = '/api/equipmentInspection/planDetail/{id}'
// 计划删除
export const planDeleted = '/api/equipmentInspection/deleted'
// 任务记录
export const planTask = '/api/equipmentInspection/planTask/{id}'
// 任务创建/更新
export const planTaskNew = '/api/equipmentInspection/task'
// 任务删除
export const taskDeleted = '/api/equipmentInspection/taskDeleted'
// 获取基数列表
export const cardinalList = '/api/baseNumber/index'
// 修改基数
export const cardinalEdit = '/api/baseNumber/edit'
// 获取包名称
export const cardinalBase = '/api/baseNumber/getBaseInstrumentset'
// 获取题目列表  保存题目
export const questionList = '/api/questionnaire/title'
// 题目详情
export const questionDetail = '/api/questionnaire/showTitle'
// 题目导出
export const exportQuestion = '/api/questionnaire/exportTitle'
// 题目导入
export const importQuestion = '/api/questionnaire/importTitle'
//删除题目
export const deleteQuestion = '/api/questionnaire/deleteTitle'
//填写考试-问卷列表
export const questionnaireList = '/api/questionnaire/index'
//问卷详情
export const questionnaireDetail = '/api/questionnaire/questionnaireDetail'
//提交问卷
export const saveAnswer = '/api/questionnaire/saveAnswer'
// 问卷管理-问卷列表
export const managementQuestionnaireList = '/api/questionnaire'
// 保存问卷
export const saveQuestionnaire = '/api/questionnaire'
// 删除问卷
export const deleteQuestionnaire = '/api/questionnaire/delete'
//问卷预览/打印
export const printQuestionnaire = '/api/questionnaire'
//复制问卷
export const copyQuestionnaire = '/api/questionnaire/copy'
//问卷结果
export const questionnaireResult = '/api/questionnaire/result'
// 问卷结果提交明细
export const questionnaireResultDetail = '/api/questionnaire/result/completion/{id}'
// 发送问卷调查相关通知
export const sendMessageForQuestionnaire = '/api/message/sendMessageForQuestionnaire'
//个人得分明细
export const userAnswerDetail = '/api/questionnaire/userAnswer/detail'
//查询考卷意见反馈
export const searchFeedback = '/api/questionnaire/opinion'
//获取科室树状结构
export const departmentTree = '/api/common/departmentTree'
//获取手术排班状态
export const getScheduleStatusUrl = '/api/operationSchedule/getScheduleStatus'
//获取手术排班列表信息
export const getOperationScheduleList = '/api/operationSchedule/list'


// 数据统计报表
// 器械包工作量统计
export const instrumentsetWorkload = '/api/report/workload/instrumentset'
// 导出器械包工作量统计
export const instrumentsetExport = '/api/report/export/workload/instrumentset'
// 灭菌设备锅次统计
export const reportSterilization = '/api/report/sterilization'
// 导出灭菌设备锅次统计
export const reportSterilizationExport = '/api/report/export/sterilization'

// 标签管理
// 标签列表
export const tagManage = '/api/tag'
// 标签模板编辑
export const tagTemplateEdit = '/api/tag/edit'
// 删除标签
export const tagManageDelete = '/api/tag/delete'
// 复制标签
export const tagManageCopy = '/api/tag/copy'
// 标签详情
export const tagManageDetail = '/api/tag/detail'
// 标签设置默认
export const tagSetDefault = '/api/tag/setDefault'
// 标签模版
export const tagManageTemplate = '/api/pack/printTagDemo'
// 标签模板列表
export const tagManageList = '/api/tag/list'
// 发送模板
export const tagSendToTenant = '/api/tag/send'
// 获取标签尺寸可选项
export const tagSizeOptions = '/api/tag/getSize'

// 消毒设备登记
export const sterilizationEquipmentRegister = '/api/equipment/sterilizationEquipmentRegister'

// 低温消毒设备登记
export const coldSterilizationEquipmentRegister = '/api/equipment/coldSterilizationEquipmentRegister'

// 清洗设备登记
export const cleanEquipmentRegister = '/api/equipment/cleanEquipmentRegister'

// 获取登记记录
export const getRegisterList = '/api/equipment/getRegisterList'

// 登记配置
export const registerConfig = '/api/common/registerConfig'

// 设备登记记录修改
export const editEquipmentRegister = '/api/equipment/editEquipmentRegister'

// 导出登记记录
export const exportRegisterList = '/api/equipment/exportRegisterList'

// 校验该设备今天是否登记
export const checkHasRegister = '/api/equipment/checkHasRegister'

// 获取SPD列表
export const getSpd = '/api/access/getSpd'

// 获取SPD绑定详情
export const getSpdDetail = '/api/access/getSpdDetail'

// spd全部绑定
export const bindSpdAll = '/api/access/bindSpdAll'

// SPD绑定/解绑
export const bindSpd = '/api/access/bindSpd'

// 驾驶舱2数据
export const getDashboard = '/api/quality/dashboard'

//驾驶舱2导出上报
export const exportDashboard = '/api/quality/dashboard/export'

// （新）主流程-发放（按发放计划）
//待发放计划列表
export const outPlan = '/api/outPlan'
// 待发放计划科室列表
export const outPlanDepartment = '/api/outPlan/department'
// 待发放计划扫码
export const outPlanScan = '/api/outPlan/scan'
// 包码绑定计划
export const outPlanBind = '/api/outPlan/bind'
// 计划外发放
export const outPlanNew = '/api/outPlan/new'
// 移除包码
export const outPlanRemove = '/api/outPlan/remove'
// 确认发放
export const outPlanSave = '/api/outPlan/save'
// 取消发放
export const outPlanCancel = '/api/outPlan/cancel'
// 获取自动检库库存列表
export const outPlanStorage = '/api/outPlan/exchange/storage'
// 待发放计划清单打印
export const outPlanPrint = '/api/outPlan/print'
// 发放单打印接口
export const outPlanCodePrint = '/api/outPlan/out_code/print'
// 发放记录列表
export const outPlanRecord = '/api/outPlan/record'
// 获取某一设备某一天的锅次和灭菌批次码
export const getPotListByEquipment = '/api/sterilization/getPotListByEquipment'
// 扫审核码获取关联的码
export const outPlanRelation = '/api/outPlan/code/relation/{code}'
// 修改发放单推车码
export const modifyOutPlanCart = '/api/outPlan/editOutCartCode'

// 质控抽查
// 列表-清洗抽查
export const sportCheckList = '/api/spotCheck/list?type={type}'

//湿包补登记根据包码获取包信息
export const getDetailByWetpackCode = '/api/common/getManageByCode'
// 查询器械包
export const spotCheckGetInstrumentset = '/api/spotCheck/getInstrumentset?type={type}'
// 抽查登记
export const spotCheckRegister = '/api/spotCheck/register?type={type}'
// 抽查详情
export const sportCheckDetail = '/api/spotCheck/detail?type={type}'
// 导出-抽查
export const spotCheckExport = '/api/spotCheck/export'
// 统计
export const spotCheckStatistics = '/api/spotCheck/statistics?type={type}'
// 获取抽查批次
export const spotCheckGetBatch = '/api/spotCheck/getBatch?type={type}'
// 统计导出
export const spotCheckStatisticsExport = '/api/spotCheck/statisticsExport'
// 删除
export const spotCheckDelete = '/api/spotCheck/del?type={type}'

// 业务管理
// 日常登记
export const dailyRecord = '/api/register'
// 日常登记导出
export const dailyRecordExport = '/api/register/export'
// 日常登记删除
export const dailyRecordDelete = '/api/register/delete'

// 自动交接
// 自动交接更新/保存
export const handCenter = '/api/handCenter'
// 自动交接删除
export const handleCenterDelete = '/api/handCenter/delete'
// 自动交接配置
export const handOverCenterConifg = '/api/common/handOverCenterConifg'

// 根据灭菌批次码获取灭菌信息
export const sterilizationInfo = '/api/common/sterilization/info/{code}'

// 第三方器械列表
export const instrumentThirdParty = '/api/instrument/thirdParty'
// 保存his code
export const instrumentSaveHisCode = '/api/instrument/saveHisCode'
// 删除his code
export const instrumentDeleteHisCode = '/api/instrument/deleteHisCode'

// 常见问题管理
// 列表
export const faqList = '/api/faq'

// 新建/编辑
export const faqSave = '/api/faq/save'

// 新建/编辑
export const faqDelete = '/api/faq/delete'

// 获取目录
export const faqCatalog = '/api/faq/catalog'

// 查询指定的问题类型
export const faqByType = '/api/faq/getFaqByType'

// 获取问题详情
export const faqDetail = '/api/faq/detail'

// 成本管理
// 成本管理列表
export const printCost = '/api/print_cost'
// 成本管理明细
export const printCostDetail = '/api/print_cost/detail'
// 成本管理明细
export const printCostCreateChart = '/api/print_cost/createChart'

// 个人中心
// 导出文件列表
export const exportFileList = '/api/common/exportList'

// 打印历史记录
export const printList = '/api/print/list'

// 批量打印
export const saveMultiple = '/api/print/saveMultiple'

// 补打明细
export const printLog = '/api/print/log/{id}'

// 获取模板
export const getTag = '/api/common/getTag'

// 标签打印/补打
export const tagTemplatePrint = '/api/print/save'

// 标签打印记录导出
export const tagPrintExport = '/api/print/export'

// 每日标签打印数量
export const tagPrintCountByDate = '/api/statistics/tagPrintCountByDate'

// 标签打印人员工作量
export const tagPrintUserWorkload = '/api/statistics/tagPrintUserWorkload'

// 打印器械包数量
export const tagPrintInstrumentset = '/api/statistics/tagPrintInstrumentset'

// 标签打印总数&补打总数
export const tagPrintCount = '/api/statistics/tagPrintCount'

// 获取灭菌失效日期
export const getSterilizeDeadlineDate = '/api/common/getSterilizationDeadlineDate'

// 获取预置模板
export const getSetedTemplate = '/api/tag/getTemplateContent'

// 获取打印详情
export const tagPrintDetail = '/api/print/detail/{id}'

// 租户管理
export const tenantManage = '/api/tenant'
// 租户管理 导入
export const tenantImport = '/api/tenant/import'

// 租户详情
export const tenantDetail = '/api/tenant/detail/{id}'

// 获取租户合同编号
export const tenantContractNos = '/api/tenant/getContractNo'

// 用户管理
export const userManage = '/api/user'

// 用户管理 短信通知
export const userSms = '/api/user/sms'

// 用户详情
export const userDetail = '/api/user/{id}'

// 删除用户
export const userDelete = '/api/user/delete/{id}'

// 轮播图管理
export const bannerManage = '/api/banner'

// 删除轮播图
export const delBanner = '/api/banner/delete/{id}'

// 获取轮播图
export const getBanner = '/api/common/getBanner'

// 轮播图 修改状态
export const changeBanner = '/api/banner/change'

// 获取门户页链接
export const linksForPortal = '/api/link'

// 获取经销商列表
export const dealerList = '/api/dealer'

// 经销商下拉
export const dealerSelect = '/api/common/getDealer'

// 获取国家
export const getCountries = '/api/common/getCountries'

// 新建/编辑经销商
export const createDealer = '/api/dealer/save'

// 删除经销商
export const delDealer = '/api/dealer/delete'

// 查看经销商详情
export const dealerDetail = '/api/dealer/detail/{id}'

// 导入经销商
export const importDealer = '/api/dealer/import'
// 字典管理列表
export const sysOptionList = '/api/system/sys_options/manage/list'
// 字典管理更新
export const sysOptionManageUpdate = '/api/system/sys_options/manage'
// 根据类型获取字典列表
export const sysOptionDetailList = '/api/system/sys_options/detail/list/{type}'
// 字典项详情
export const sysOptionDetailInfo = '/api/system/sys_options/{id}'
// 字典新增
export const sysOptionDetailSave = '/api/system/sys_options/save'
// 字典编辑
export const sysOptionDetailEdit = '/api/system/sys_options/edit'
// 删除字典项
export const sysOptionDelete = '/api/system/sys_options/delete/{id}'
// 批量删除字典
export const sysOptionBatchDelete = '/api/system/sys_options/batchDetail'
// 更新字典排序
export const sysOptionUpdateSort = '/api/system/sys_options/updateSort'
// 租户是否第一次打印/补打
export const isFirstPrint = '/api/print/isFirstPrint'
